<template>
  <div>
    <confirm-dialog ref="confirm">
      <v-row slot="action" no-gutters>
        <v-spacer></v-spacer>
        <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
          style="color: white" @click="confirmDialogConfirmFunction()" :disabled="disabelConfirm">
          بله
        </v-btn>
        <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
          @click="confirmDialogCancelFunction()">
          خیر
        </v-btn>
      </v-row>
    </confirm-dialog>
    <v-dialog width="450" v-model="searchModal">
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-magnify</v-icon>
              <span class="modal-title-text mr-2">جستجو</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-12">
          <v-row>
            <v-col cols="12">
              <v-text-field type="text" v-model="searchFullName" dense clearable clear-icon="mdi-close-circle-outline"
                outlined v-on:keyup.enter="search()" label="نام و نام خانوادگی" class="input-label"
                prepend-inner-icon="mdi-account mdi-18px"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field type="text" v-model="searchNationalCode" dense clearable
                clear-icon="mdi-close-circle-outline" outlined v-on:keyup.enter="search()" label="کد ملی"
                class="input-label" prepend-inner-icon="mdi-card-account-details mdi-18px"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field type="text" v-model="searchMainPhoneNumber" dense clearable
                clear-icon="mdi-close-circle-outline" outlined v-on:keyup.enter="search()" label="شماره همراه"
                class="input-label" prepend-inner-icon="mdi-phone mdi-flip-h mdi-18px"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-autocomplete :items="allCitysForOther" no-data-text="اطلاعاتی وجود ندارد" tabindex="3" dense outlined
                clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id" label="شهرستان"
                v-model="searchCityId" autocomplete="off" prepend-inner-icon="mdi-home-city mdi-18px"
                style="font-size: 11px !important"></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="search()" dark rounded class="normal-letter-spacing px-12">
            جستجو
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelSearch()" class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog width="900" v-model="showAddEditModal" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">{{ modalIcon }}</v-icon>
              <span class="modal-title-text mr-2">{{ modalTitle }}</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-12">
          <v-row>
            <v-col cols="6">
              <v-text-field type="text" v-model="disabledPeople.firstName" dense outlined
                v-on:keyup.enter="showConfirmDialogFunction()" label="نام*" clearable :autofocus="true"
                clear-icon="mdi-close-circle-outline" class="input-label"
                prepend-inner-icon="mdi-account mdi-18px"></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field type="text" v-model="disabledPeople.lastName" dense outlined
                v-on:keyup.enter="showConfirmDialogFunction()" label="نام خانوادگی*" clearable
                clear-icon="mdi-close-circle-outline" class="input-label"
                prepend-inner-icon="mdi-account mdi-18px"></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field type="text" v-model="disabledPeople.nationalCode" dense outlined
                v-on:keyup.enter="showConfirmDialogFunction()" label="کد ملی*" clearable maxlength="10"
                @keypress="isNumber($event)" clear-icon="mdi-close-circle-outline" class="input-label"
                prepend-inner-icon="mdi-card-account-details mdi-18px"></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field type="text" outlined id="user-brithDate" ref="dateTimeAdd" dense clearable
                @click:clear="clearBirthDate()" clear-icon="mdi-close-circle-outline"
                v-model="tempDisabledPeopleBrithDate" @focus="showDisabledPeopleBrithDate = true"
                @click="showDisabledPeopleBrithDate = true" label="تاریخ تولد"
                prepend-inner-icon="mdi-calendar-range mdi-18px">
                <template slot="append">
                  <v-icon @click="showDisabledPeopleBrithDate = true" class="calender-background ml-n3 mt-n2"
                    color="white">
                    mdi-calendar-range mdi-18px
                  </v-icon>
                </template>
              </v-text-field>
              <date-picker :show="showDisabledPeopleBrithDate" simple :max="maxDate" v-model="disabledPeople.birthDate"
                :min="minDate" @change="disabledPeopleBrithDateChange()" :editable="true" format="YYYY-MM-DD"
                display-format="jYYYY/jMM/jDD" custom-input="#userr1-brithDate"
                @close="showDisabledPeopleBrithDate = false" />
            </v-col>
            <v-col cols="6">
              <v-text-field type="text" v-model="disabledPeople.mainPhoneNumber" dense outlined
                v-on:keyup.enter="showConfirmDialogFunction()" label="شماره اصلی*" maxlength="11"
                @keypress="isNumber($event)" clearable clear-icon="mdi-close-circle-outline" class="input-label"
                prepend-inner-icon="mdi-phone mdi-flip-h mdi-18px"></v-text-field>
            </v-col>
            <v-col cols="6" v-for="item in disabledPeoplephoneNumbers" :key="item.id">
              <v-text-field type="text" v-model="item.text" dense clearable clear-icon="mdi-close-circle-outline"
                maxlength="11" @keypress="isNumber($event)" append-outer-icon="mdi-close"
                @click:append-outer="removePhoneNumber(item.id)" outlined v-on:keyup.enter="showConfirmDialogFunction()"
                label="شماره دیگر" class="input-label"
                prepend-inner-icon="mdi-phone mdi-flip-h mdi-18px"></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-card height="5.3vh" elevation="0" class="card-add-phoneNumber" @click="addPhoneNumber()">
                <v-card-text>
                  <v-row class="card-add-phoneNumber-items">
                    <v-icon color="#CDCBCF" class="mr-2">mdi-phone mdi-flip-h mdi-18px</v-icon>
                    <span class="mr-3 card-add-phoneNumber-items-text">شماره دیگر</span>
                    <v-spacer></v-spacer>
                    <v-icon color="#212121">mdi-plus mdi-18px</v-icon>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-text-field type="text" v-model="disabledPeople.address" dense outlined
                v-on:keyup.enter="showConfirmDialogFunction()" label="آدرس*" clearable
                clear-icon="mdi-close-circle-outline" class="input-label"
                prepend-inner-icon="mdi-map-marker mdi-18px"></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-autocomplete :items="allCitysForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                item-text="title" item-value="id" label="شهرستان*" clearable clear-icon="mdi-close-circle-outline"
                v-model="disabledPeople.cityId" autocomplete="off" prepend-inner-icon="mdi-home-city mdi-18px"
                style="font-size: 11px !important"></v-autocomplete>
            </v-col>
            <v-col cols="6" v-if="!addFlag">
              <v-checkbox v-model="isActive" label="فعال" hide-details></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="showConfirmDialogFunction()" dark rounded
            class="normal-letter-spacing px-12">
            ثبت
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelAddEditFunction()"
            class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row no-gutters class="table-content">
      <v-col cols="12" class="mr-2">
        <v-img :src="tableImg.val">
          <v-row>
            <v-col cols="3">
              <v-img :src="tableTitleImage.val" contain max-height="14vh" max-width="27vh">
                <v-row>
                  <v-col cols="1"></v-col>
                  <v-col class="header-title" cols="10">
                    <span class="header-title-content">مدیریت افرد ناتوان</span>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-img>
            </v-col>
            <v-col cols="3" class="mr-n11">
              <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense
                v-model="searchTitle" class="mt-3 mr-n16"></v-text-field>
            </v-col>
            <v-col cols="1" class="mr-n3">
              <v-btn class="mx-2 mt-3 mr-n16" fab dark small @click="showSearchModal()" color="darkColor" elevation="0">
                <v-icon dark>mdi-filter mdi-18px</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="1" class="mr-n16 mt-6" v-if="isSearch">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon light v-bind="attrs" v-on="on" @click="removeFilters()" class="mr-n16">
                    mdi-filter-remove mdi-18px
                  </v-icon>
                </template>
                <span>حذف فیلتر ها</span>
              </v-tooltip>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="2" class="text-left">
              <v-btn rounded color="darkColor" dark @click="enableAddEditFunction(1, 0)"
                class="mt-3 normal-letter-spacing ml-3">
                <v-icon class="ml-1">mdi-plus mdi-18px</v-icon>
                افزودن فرد ناتوان
              </v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters class="background-main mx-2">
            <v-col cols="12">
              <v-card elevation="0" class="card-width body-card">
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <template>
                        <v-data-table fixed-header :headers="disabledPeopleManagmentInformationTableHeaders"
                          :items="disabledPeopleFilteredList" :page.sync="page"
                          :items-per-page="disabledPeopleFilteredList.length" height="62vh" :hide-default-footer="true"
                          multi-sort class="elevation-0">
                          <template v-slot:[`item.status`]="{ item }">
                            <v-tooltip top v-if="item.status == false">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mt-1" color="#F56060" v-bind="attrs" v-on="on">
                                  mdi-close-circle
                                </v-icon>
                                <span class="mt-1 mr-1">غیر فعال</span>
                              </template>
                              <span>غبر فعال</span>
                            </v-tooltip>
                            <v-tooltip top v-else>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mt-1" color="#3BCA79" v-bind="attrs" v-on="on">
                                  mdi-check-circle
                                </v-icon>
                                <span class="mt-1 mr-1">فعال</span>
                              </template>
                              <span>فعال</span>
                            </v-tooltip>
                          </template>
                          <template v-slot:[`item.actions`]="{ item }">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mt-1 mr-5" color="iconColor" style="cursor: pointer"
                                  @click="enableAddEditFunction(2, item.id)" v-bind="attrs" v-on="on">
                                  mdi-pencil
                                </v-icon>
                              </template>
                              <span>ویرایش</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mt-1 mr-5" color="iconColor" style="cursor: pointer"
                                  @click="showDeleteConfirmFunction(item.id)" v-bind="attrs" v-on="on">
                                  mdi-delete
                                </v-icon>
                              </template>
                              <span>حذف</span>
                            </v-tooltip>
                          </template>
                          <template v-slot:no-data>
                            <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                          </template>
                        </v-data-table>
                      </template>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <pagination-component ref="pagination">
                <div slot="action">
                  <v-card elevation="0">
                    <v-pagination class="mt-8" circle color="lightColor" v-model="page" :length="totalPages"
                      :total-visible="8" :value="totalPages" prev-icon="mdi-chevron-left" next-icon="mdi-chevron-right"
                      @next="next()" @previous="previous()" @input="input()"></v-pagination>
                  </v-card>
                </div>
              </pagination-component>
            </v-col>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import Vue from 'vue';
import confirmDialog from '../../components/ConfirmDialog.vue';
import AlertComponent from '../../components/AlertComponent.vue';
import PaginationComponent from '../../components/PaginationComponent.vue';

import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import pagination from '@/Mixins/Pagination';
import disabledPeopleMixin from '@/Mixins/BaseInformation/DisabledPeopleMixin';
import disabledPeopleHelper from '@/Helpers/BaseInformation/DisabledPeopleHelper';
import CityMixin from '@/Mixins/BaseInformation/CityMixin';
export default {
  name: 'DisabledPeopleManagment',
  title: 'افرد ناتوان',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    confirmDialog,
    AlertComponent,
    PaginationComponent,
  },
  mixins: [
    pagination,
    ShearedMixin,
    disabledPeopleMixin,
    disabledPeopleHelper,
    snackBar,
    ShearedHelper,
    CityMixin,
  ],
  created() {
    this.$root.$refs.DisabledPeopleManagment = this;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {};
  },
  methods: {
    mounte: function () {
      let currentDate = Vue.moment().format('YYYY/MM/DD');
      this.maxDate = currentDate;
      // this.$refs.pagination.newPageSize = 10;
      // this.$refs.pagination.pageSize = 10;
      this.getListOfDisabledPeoplesWithPagination();
      this.getListOfCitysForOther();
    },
    previous: function () {
      this.getListOfDisabledPeoplesWithPagination();
      this.$refs.pagination.page = this.page;
    },
    next: function () {
      this.getListOfDisabledPeoplesWithPagination();
      this.$refs.pagination.page = this.page;
    },
    input: function () {
      this.getListOfDisabledPeoplesWithPagination();
      this.$refs.pagination.page = this.page;
    },
  },
  computed: {
    disabledPeopleFilteredList() {
      return this.disabledPeoplePaginationList.filter((u) => {
        return (
          u.fullName.toLowerCase().includes(this.searchTitle.toLowerCase()) ||
          u.nationalCode.toLowerCase().includes(this.searchTitle.toLowerCase())
        );
      });
    },
  },
};
</script>
<style scoped>
.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.modal-title-text {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
}

.card-add-phoneNumber {
  border: 2px solid #cdcbcf !important;
}

.card-add-phoneNumber-items {
  margin-top: -7px !important;
}

.card-add-phoneNumber-items-text {
  color: #cdcbcf !important;
}

.body-card {
  overflow-y: auto !important;
}

.calender-background {
  background: #79747e;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 12px;
  padding-bottom: 12px;
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 5px !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}
</style>
